import { POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES } from 'shared/constants/transportAccessibilityInfrastructure';
import { EInsideTAInfrastructureType } from 'shared/types/map';

export function isRouteForTypeAvailable(type: string) {
  return !POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES.includes(type as EInsideTAInfrastructureType) && type !== 'futureRoad';
}
